import React from "react";

export default function MemeItem({ meme, selected, onSelect }) {
  return (
    <button
      type="button"
      className={`meme-item${selected ? " is-selected" : ""}`}
      onClick={() => onSelect(meme)}
      aria-pressed={selected}
      title={`Use the "${meme.name}" template`}
    >
      <img src={meme.url} alt={meme.name} className="meme-img" loading="lazy" />
      <span className="meme-txt">{meme.name}</span>
    </button>
  );
}
